<template>
  <div id="titleWStar">
    <div class="text-5xl font-bold text-center" :style="'color:' + titleColor" v-html="t(title)" />
    <img :src="commonStore.getImgUrl(starIconObj.componentName, starIconObj.imgName, starIconObj.imgFormat)" class="m-auto mt-2 mb-16" style="width: 1.76vw" :class="[customStyle]" v-if="Object.keys(starIconObj).length != 0" />
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import { useCommonStore } from "@/stores/common";
import { useI18n } from "vue-i18n";

const commonStore = useCommonStore();
const { t, locale } = useI18n();

onMounted(async () => {}); 

import { toRefs } from "vue";

const props = defineProps({
  title: {
    type: String,
    default: "",
  },
  titleColor: {
    type: String,
    default: "#494949",
  },
  starIconObj: {
    type: Object,
    default: {},
    //{ componentName: 'telemedicine', imgName: 'starIconLightBlue', imgFormat: 'svg' }
  },
  customStyle: {
    type: String,
  },
});
//const { label } = toRefs(props);
</script>

<style>
</style>